window.mcb.forms.standard = (function () {
  const getAutoFillRepeatedNr = function (number, length) {
    let result = number.toString();
    while (result.length < length) {
      result += result;
    }

    return result.substring(0, length);
  }

  let initForm = async function (parameters) {
    let _forceAutoDuringTesting = true;
    let _autoFill = window.mcb.utilities.browser.getUrlBooleanParameter('auto', _forceAutoDuringTesting && window.mcb.forms.debug)

    if (typeof parameters.personalize !== "undefined" && parameters.personalize !== null && parameters.personalize.active === true) {
      const personalizations = await getPersonalizations(parameters);
      if (typeof personalizations.prefills !== "undefined") {
        parameters.logic.prefills = personalizations.prefills;
      }
      else {
        return;
      }
    }
    else {
      parameters.logic.prefills = [];
    }

    let form = window.mcb.forms.core(parameters);

    form.render();

    if (_autoFill) {
      const formElement = document.getElementById(parameters.targetId);
      formElement.querySelectorAll('.' + window.mcb.forms.constants.fields.collectionClass).forEach(function (collection) {
        if (collection.offsetParent !== null) {
          const checkboxes = collection.querySelectorAll('.' + window.mcb.forms.constants.fields.uiInput + '[type="checkbox"]:enabled');
          if (checkboxes.length > 0) {
            const randomCheckboxes = [...checkboxes].sort(() => .5 - Math.random()).slice(0, Math.max(1, Math.round(checkboxes.length / 3)));
            randomCheckboxes.forEach(function (checkbox) {
              checkbox.checked = true;
              checkbox.dispatchEvent(new Event('blur', {
                bubbles: true,
                cancelable: true
              }));
            });
          }

          const radios = collection.querySelectorAll('.' + window.mcb.forms.constants.fields.uiInput + '[type="radio"]:enabled');
          if (radios.length > 0) {
            const randomRadio = [...radios].sort(() => .5 - Math.random()).slice(0, 1)[0];
            randomRadio.checked = true;
            randomRadio.dispatchEvent(new Event('blur', {
              bubbles: true,
              cancelable: true
            }));
          }
        }
      });

      let index = 0;

      formElement.querySelectorAll('.' + window.mcb.forms.constants.fields.uiInput).forEach(function (input) {
        if (input.offsetParent !== null && input.type !== 'checkbox' && input.type !== 'radio') {
          if (input.tagName === 'SELECT') {
            const options = input.querySelectorAll('option:enabled');
            if (options.length > 0) {
              input.selectedIndex = Math.floor(Math.random() * options.length + 1);
            }
          }
          else {
            if (input.classList.contains(window.mcb.forms.constants.fields.dateClass)) {
              let date = new Date();
              date.setDate(date.getDate() + Math.round(Math.random() * 10));
              input.value = date.getDay().toString().padStart(2, '0') + '-' + date.getMonth().toString().padStart(2, '0') + '-' + date.getFullYear();
            }
            else if (input.classList.contains('mcb-webform--field--type--cpr')) {
              input.value = '0703961576';
            }
            else {
              // the following increases index for each input field

              if (input.tagName === 'TEXTAREA') {
                input.innerText = 'Textarea\r\n ' + (index);
              }
              else if (input.classList.contains('mcb-webform--field--type--postal')) {
                input.value = getAutoFillRepeatedNr(index, 4);
              }
              else if (input.classList.contains('mcb-webform--field--type--phone')) {
                input.value = getAutoFillRepeatedNr(index, 8);
              }
              else if (input.classList.contains(window.mcb.forms.constants.fields.currencyClass) || input.classList.contains(window.mcb.forms.constants.fields.numberClass)) {
                input.value = Math.min(
                  (input.dataset.min ?? 0) + Math.round(Math.random() * index + 1),
                  (input.dataset.max ?? Number.MAX_SAFE_INTEGER));
              }
              else if (input.classList.contains('mcb-webform--field--type--mail')) {
                input.value = 'test_' + index + '@test.dk';
              }
              else if (input.classList.contains('mcb-webform--field--type--cvr')) {
                input.value = window.mcb.forms.helpers.generateModulusValue(index.toString(), 11, [2, 7, 6, 5, 4, 3, 2, 1]);
              }
              else if (input.classList.contains('mcb-webform--field--type--cpr')) {
                input.value = '010150' + getAutoFillRepeatedNr(index, 4);
              }
              else if (input.type === 'text') {
                input.value = 'Text ' + (index);
              }

              index++;
            }
          }

          input.dispatchEvent(new Event('blur', {
            bubbles: true,
            cancelable: true
          }));
        }
      });
    }
  };

  const getPersonalizations = async function (parameters) {
    const canvas = document.getElementById(parameters.targetId);

    const loadingMessage = document.createElement('div');
    if (typeof parameters.personalize.loadingMessage == "string") {
      loadingMessage.className = 'webform__messages';
      loadingMessage.innerHTML = `<div class="mcb-form-block--warning-view-model warning">${parameters.personalize.loadingMessage}</div>`;
      canvas.append(loadingMessage);
    }

    const token = window.mcb.utilities.browser.getUrlParameter(parameters.personalize.requiredQueryKey, 'null');

    const formData = new FormData();
    formData.append('mc_identity', parameters.identity);
    formData.append('mc_token', token);

    var url = parameters.settings.submitUrlBase + '/personalizations';
    const response = await fetch(url, {
      method: 'post',
      body: formData
    });

    loadingMessage.remove();
    if (response.ok !== true) {
      let message = `An error has occured: ${response.status} posting to '${url}'`;
      if (typeof response.body !== "undefined") {
        message = await response.json();
        if (typeof message.error !== "undefined") {
          message = message.error
        }
        else {
          message = message.title
        }
      }

      canvas.outerHTML = `<div class="webform__messages"><div class="mcb-form-block--warning-view-model warning">${message}</div></div>`;
      return {};
    }

    return await response.json();
  };

  return _ = {
    initForm: initForm
  };
})();
